import { CallTypes } from '@constants/Calls';

// TODO: Need to list all errors anyway for i18nAlly to list them.
export const getErrorTranslation = (type: number, label: string): string => {
  return `error_${CallTypes[type]}_${label}`;
};
